<template>
    <div id="main">
        <AtendimentoList 
            v-show="!rotaAninhada" 
            :reloadData="reloadData" 
            @abaSelecionada="updateAba"
        />
        <router-view />
    </div>
</template>

<script>
import AtendimentoList from '@/components/vendas/atendimento/AtendimentoList.vue';

export default {
    name: 'AtendimentoListRoute',
    beforeRouteLeave(to, from, next) {
        if (this.$cookies.get('atendimento') == undefined) {
            this.$cookies.set('atendimento', this.abaSelecionada === 1);
        }
        next();
    },
    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'ven-atendimento-list';
        if (from.name != 'ven-atendimento-list' && to.name == 'ven-atendimento-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 700);
        }
        next();
    },
    components: {
        AtendimentoList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
            abaSelecionada: 0,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('ven-atendimento') &&
            this.$route.name != 'ven-atendimento-list';
    },
    methods: {
        updateAba(aba) {
            this.abaSelecionada = aba;
        }
    }
};
</script>
<style lang="scss" scoped>
    #main {
        padding: 0 20px;
        height: 100%;
    }
</style>
